export default __webpack_public_path__ + "static/media/tailP.ac2d96d7.png";